import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import loginBG from "../../assets/loginBG.png";
import axiosInstance from "../../axiosInstance";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../redux/features/auth/authSlice";

// import googleLogo from "../resources/googleLogo.png";
// import fbLogo from "../resources/fbLogo.png";

function ForgotPassword() {
  let from = "none";
  const { state } = useLocation();
  if (state) from = state.from;
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  interface FormValues {
    username?: string;
    password?: string;
  }

  const [isVisible, setVisibility] = useState<Boolean>(false);

  const [formValues, setFormValues] = useState<FormValues>({
    username: "",
  });

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const handleChangeVisibility = () => {
    setVisibility(!isVisible);
  };

  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleOnSubmit = () => {
    // api call with form data stored in an array name FormValue with username and password as data
    axiosInstance
      .post(`${process.env.REACT_APP_BASEURL}/users/auth/password/forgot/`, {
        email: formValues.username,
      })
      .then((resp) => {
        console.log(resp.data.message);
        setSuccessMessage(resp.data?.message);
        // console.log(resp.data.refresh); */
        /* dispatch(setCredentials({ user: null, accessToken: resp.data.access})); */
        // return redirectDocument("/dashboard");
        // <Navigate to='/dashboard' replace = {true} />
      })
      .catch((error) => {
        setErrorMessage(error.response?.data?.message || "Incorrect Email");
        /* console.log(localStorage.getItem("access_token"));
        console.log(localStorage.getItem("refresh_token")); */
        setFormValues({ username: "" });
      });
  };

  const goToSignup = () => {
    navigate("/signup");
  };

  const isFormValid = formValues.username;
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          background: `url(${loginBG}) , lightgray 50% / cover no-repeat`,
          backgroundSize: "cover",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            padding: "40px 50px",
            flexDirection: "column",
            alignItems: "center",
            gap: "33px",
            borderRadius: "16px",
            background: "#FBE5C6",
            border: "2px solid #1a1a1a",
          }}
        >
          <Box sx={{ height: "91.204px", width: "105.313px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="96"
              height="110"
              viewBox="0 0 96 110"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.0009 2L93.6018 28.3283V80.9839L48.0009 107.313L2.39819 80.9839V28.3283L48.0009 2Z"
                stroke="#FF9A56"
                strokeWidth="3.59941"
                strokeMiterlimit="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.5623 69.9565L65.9584 96.2337"
                stroke="#FF9A56"
                strokeWidth="3.78886"
                strokeMiterlimit="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M74.6055 69.9565L29.2772 96.2336"
                stroke="#FF9A56"
                strokeWidth="3.81813"
                strokeMiterlimit="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M47.9983 2V54.6563M47.9983 54.6563L2.94873 80.8096M47.9983 54.6563L93.6012 80.6264"
                stroke="#FF9A56"
                strokeWidth="3.59941"
                strokeMiterlimit="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.2759 18.6323L21.3536 50.033L21.3345 69.6664"
                stroke="#FF9A56"
                strokeWidth="3.78886"
                strokeMiterlimit="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M48.2749 3.3501L74.6075 69.9564"
                stroke="#FF9A56"
                strokeWidth="3.78886"
                strokeMiterlimit="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "5.5px",
            }}
          >
            <Typography
              sx={{
                display: "inline",
                color: "#282828",
                fontFeatureSettings: `'clig' off, 'liga' off`,
                fontFamily: "Poppins",
                fontSize: "26.4px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "39.6px" /* 150% */,
              }}
            >
              Jump Right Back into
              <Typography
                component="span"
                sx={{
                  color: "#FF9A56",
                  fontFeatureSettings: `'clig' off, 'liga' off`,
                  fontFamily: "Poppins",
                  fontSize: "26.4px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "39.6px",
                }}
              >
                {" "}
                GPlan
              </Typography>
            </Typography>
            <Typography
              sx={{
                color: "#949CA9",
                /* SubText */
                fontFamily: "Poppins",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "24px" /* 150% */,
              }}
            >
              Reset Your Password
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "22px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "506px",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "5.5px",
              }}
            >
              <Typography
                sx={{
                  alignSelf: "stretch",
                  color: "#282828",

                  /* SubText */
                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "24px",
                }}
              >
                Email
              </Typography>
              <TextField
                fullWidth
                size="small"
                required
                InputLabelProps={{
                  shrink: false,
                  style: {
                    color: "#949CA9",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "24px",
                  },
                }}
                label={
                  formValues.username === ""
                    ? "Enter your registered Email"
                    : ""
                }
                name="username"
                value={formValues.username}
                onChange={handleTextFieldChange}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleOnSubmit();
                  }
                }}
              />
            </Box>
            {successMessage && (
              <Typography
                sx={{
                  color: "green",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "15px",
                  alignSelf: "stretch",
                }}
              >
                {successMessage}
              </Typography>
            )}
            {errorMessage && (
              <Typography
                sx={{
                  color: "red",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "15px",
                  alignSelf: "stretch",
                }}
              >
                {errorMessage}
              </Typography>
            )}
            <Button
              fullWidth
              size="large"
              onClick={handleOnSubmit}
              variant="contained"
              disabled={!isFormValid}
              sx={{
                backgroundColor: isFormValid ? "#FF9A56" : "#CECECE",
                color: "#1a1a1a",
                border: "2px solid #1a1a1a",
                borderRadius: "12px",
                transition: "all 0.1s ease",
                "&:hover": {
                    backgroundColor: "#e8894d",
                },
              }}
            >
              <Typography
                sx={{
                  color: "#1a1a1a",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "26.4px",
                }}
              >
                Send Reset Link
              </Typography>
            </Button>
          </Box>
          <Typography
            sx={{
              color: "#282828",
              fontFamily: "Poppins",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
            }}
          >
            {" "}
            New to GPlan?{" "}
            <Button onClick={goToSignup}>
              <Typography
                component="span"
                sx={{
                  color: "#FF9A56",

                  fontFamily: "Poppins",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "24px",
                }}
              >
                Get Started
              </Typography>
            </Button>
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default ForgotPassword;
